// import { supabaseClient } from './supabaseClient'; // Ensure your Supabase client is correctly set up
import { supabaseClient } from '@/supabase/app';
import { enqueueSnackbar } from 'notistack';

export interface AppNotification {
  id: number;
  title: string;
  message: string;
  is_read: boolean;
  status: "current" | "archived";
  created_at: string;
}
// Fetch all notifications
export async function getAllNotifications(): Promise<AppNotification[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("notifications")
      .select("*");

    if (error) {
      throw error;
    }
    return data as AppNotification[];
  } catch (error) {
    enqueueSnackbar(`Error fetching notifications: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

// Update the status of a single notification
export async function updateNotificationStatus(
  id: number,
  newStatus: boolean
): Promise<void> {
  try {
    const { error } = await supabaseClient
      .from("notifications")
      .update({ is_read: newStatus })
      .eq("id", id);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Notification status updated successfully!", {
      variant: "success",
    });
  } catch (error) {
    enqueueSnackbar(`Error updating notification: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function updateNotificationStatus1(
    id: number,
    newStatus: string
  ): Promise<void> {
    try {
      const { error } = await supabaseClient
        .from("notifications")
        .update({ status: newStatus })
        .eq("id", id);
  
      if (error) {
        throw error;
      }
  
      enqueueSnackbar("Notification status updated successfully!", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(`Error updating notification: ${error.message}`, {
        variant: "error",
      });
    }
  }

// Update the status of all notifications
export async function updateAllNotificationsStatus(): Promise<void> {
    try {
      // Update notifications where `is_read` is false
      const { error } = await supabaseClient
        .from("notifications")
        .update({ is_read: true }) // Mark all as read
        .eq("is_read", false); // Only target unread notifications
  
      if (error) {
        throw error;
      }
  
      enqueueSnackbar("All unread notifications marked as read!", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(`Error updating notifications: ${error.message}`, {
        variant: "error",
      });
    }
  }
  
  export async function getUnreadNotificationsCount(): Promise<number> {
    try {
      const { count, error } = await supabaseClient
        .from("notifications")
        .select("id", { count: "exact" }) // Specify you want the exact count
        .eq("is_read", false); // Only count unread notifications
  
      if (error) {
        throw error;
      }
  
      return count || 0; // Return the count or 0 if undefined
    } catch (error) {
      enqueueSnackbar(`Error fetching unread notifications count: ${error.message}`, {
        variant: "error",
      });
      return 0; // Return 0 in case of an error
    }
  }
  
// Add a new notification
export async function addNotification(
  title: string,
  message: string,
  // status: string = "unread"
): Promise<void> {
  try {

    console.log("I am in adding noti")
    const { error } = await supabaseClient
      .from("notifications")
      .insert([{ title, message }]);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Notification added successfully!", {
      variant: "success",
    });
  } catch (error) {
    enqueueSnackbar(`Error adding notification: ${error.message}`, {
      variant: "error",
    });
  }
}

// Delete a notification
export async function deleteNotification(id: number): Promise<void> {
  try {
    const { error } = await supabaseClient
      .from("notifications")
      .delete()
      .eq("id", id);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Notification deleted successfully!", {
      variant: "success",
    });
  } catch (error) {
    enqueueSnackbar(`Error deleting notification: ${error.message}`, {
      variant: "error",
    });
  }
}
